module.exports = __webpack_public_path__ + "media/images/sampleBet__kranz-65592244c540e52ed843418c252f6418.png";